// extracted by mini-css-extract-plugin
export var description = "ParagraphSupportWidgetPrimary-module--description--3b452";
export var heading = "ParagraphSupportWidgetPrimary-module--heading--f3e84";
export var inner = "ParagraphSupportWidgetPrimary-module--inner--179c1";
export var textarea = "ParagraphSupportWidgetPrimary-module--textarea--38e13";
export var title = "ParagraphSupportWidgetPrimary-module--title--7223d";
export var widgetarea = "ParagraphSupportWidgetPrimary-module--widgetarea--e84e1";